import React, { FC, useEffect, useRef, useState } from 'react';
import { COLORS } from '~/src/styles/tokens/colors';
import * as Styled from './info-badge.styles';

interface InfoBadgeProps {
    text?: string;
    icon?: React.ReactNode;
    backgroundColor?: string;
    textColor?: string;
    dismissTime?: number;
    onDismiss?: () => void;
    headerHeight?: string;
    children?: React.ReactNode;
}

export const InfoBadge: FC<InfoBadgeProps> = ({
    text,
    icon,
    backgroundColor = COLORS.backgroundLightInverted,
    textColor = COLORS.textLightInverted,
    dismissTime = 3000,
    onDismiss,
    children,
}) => {
    const [isVisible, setIsVisible] = useState(true);
    const [width, setWidth] = useState(0);
    const chipsRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            if (onDismiss) {
                onDismiss();
            }
        }, dismissTime);

        return () => clearTimeout(timer);
    }, [dismissTime, onDismiss]);

    useEffect(() => {
        chipsRef.current && setWidth(chipsRef.current.getBoundingClientRect().width);
    }, [chipsRef.current]);

    if (!isVisible) {
        return null;
    }

    return (
        <Styled.OuterContainer ref={chipsRef} shift={Math.floor(width / 2)}>
            <Styled.BadgeContainer
                backgroundColor={backgroundColor}
                textColor={textColor}
                isVisible={isVisible}
            >
                {icon && <Styled.IconWrapper>{icon}</Styled.IconWrapper>}
                {text && <Styled.BadgeText>{text}</Styled.BadgeText>}
                {children}
            </Styled.BadgeContainer>
        </Styled.OuterContainer>
    );
};
